import { loadScript } from '@revolugo/elements-core/script'

// eslint-disable-next-line no-console
loadScript().catch((error: unknown) => console.error(error))
